import {
  BodyText,
  Field,
  FieldError,
  FieldLabel,
  Input,
} from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { SubmitCancelButtons } from "./SubmitCancelButtons";
import type {
  GenericObservationDisplayProps,
  GenericObservationFormProps,
} from "./types";

const formSchema = z.object({
  value: z.number().default(0),
});

export const GenericObservationNumberForm = ({
  patientId,
  item,
  itemCategory,
  onSubmit,
  onCancel,
  isSubmitting,
}: GenericObservationFormProps) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      value: item.documentedObservation?.valueInteger ?? 0,
    },
  });
  const handleSubmit = (data: z.infer<typeof formSchema>) => {
    const fhirValue = {
      valueInteger: data.value,
    };
    const payload = {
      patientId: patientId as string,
      category: itemCategory,
      status: "final",
      code: {
        coding: [
          {
            code: item.observationCode,
            system: item.observationCodeSystem,
            display: item.observationCodeDisplay,
          },
        ],
        text: item.observationCodeFriendlyDisplay,
      },
      fhirValue,
    };
    onSubmit(payload);
  };
  return (
    <form onSubmit={form.handleSubmit(handleSubmit)}>
      <div className="flex flex-col gap-2">
        <Controller
          control={form.control}
          name="value"
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
              <FieldLabel htmlFor="value">
                <BodyText size="sm" bold>
                  {item.observationCodeFriendlyDisplay}
                </BodyText>
              </FieldLabel>
              <Input
                {...field}
                id="value"
                autoFocus
                type="number"
                onChange={(e) => {
                  form.setValue("value", Number.parseInt(e.target.value));
                }}
                aria-invalid={fieldState.invalid}
              />
              <FieldError errors={[fieldState.error]} />
            </Field>
          )}
        />
        <SubmitCancelButtons isSaving={isSubmitting} onCancel={onCancel} />
      </div>
    </form>
  );
};

export const GenericObservationNumberDisplay = ({
  item,
}: GenericObservationDisplayProps) => {
  return (
    <BodyText size="sm">
      {item.documentedObservation?.valueInteger !== undefined
        ? item.documentedObservation.valueInteger.toString()
        : "Unknown"}
    </BodyText>
  );
};
